import React, { useState } from 'react'

import { Box } from '@material-ui/core'
import CalistaUiComponentTranslationText from 'src/views/common/CalistaUiComponentTranslationText'
import CancelIcon from '@material-ui/icons/Cancel'
import EditIcon from '@material-ui/icons/Edit';
import FavoriteBorderIcon from '@material-ui/icons/FavoriteBorder'
import FileCopyIcon from '@material-ui/icons/FileCopy'
import IconButton from '@material-ui/core/IconButton'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import MoreHorizOutlinedIcon from '@material-ui/icons/MoreHorizOutlined';
import SettingsOutlinedIcon from '@material-ui/icons/SettingsOutlined'
import SyncAltOutlinedIcon from '@material-ui/icons/SyncAltOutlined'
import Typography from '@material-ui/core/Typography'
import pathMap from 'src/paths/PathMap_FreightBooking'
import Utils from 'src/views/freightbooking/shared/Utils'
import { useHistory } from 'react-router-dom'

export default function CarrierBookingActionMenu(props) {
  const { booking } = props
  const translatedTextsObject = CalistaUiComponentTranslationText()
  const [anchorEl, setAnchorEl] = useState(null)
  const history = useHistory()

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  console.log(booking)
  return (
    <Box >
      <IconButton
        aria-label='more'
        aria-controls='long-menu'
        aria-haspopup='true'
        onClick={handleClick}
        className={'moreMenuBtn'}
      >
        <MoreHorizOutlinedIcon />
      </IconButton>
      {Utils.AmendButtonShowStatus.includes(booking.bookStatus + "") && (<Menu
        id='simple-menu'
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem
          onClick={() => {

            // booking.prevPage = props.page
            history.push({
              pathname: pathMap.MANAGE_BOOKING_AMEND,
              state: { booking: booking, prevPage: props.page }
            })
          }
            // history.push()
          }
        >
          <ListItemIcon>
            <EditIcon fontSize='small' />
          </ListItemIcon>
          <Typography variant='inherit' style={{ fontSize: 'small' }}>
            {translatedTextsObject.edit}
          </Typography>
        </MenuItem>

      </Menu>)}
    </Box>
  )
}
